import { numberToAlphabet } from '../../../../utils';

interface Props {
    answer: string;
    index: number;
    classNames?: string | boolean;
}

export const SSPollAnswerText = ({ answer, index, classNames }: Props) => (
    <>
        <span
            className={`absolute capitalize top-2 w-8 h-8 border-2 border-primary rounded-full left-1 font-medium inline-flex justify-center items-center group-hover:bg-primary group-hover:text-on-primary group-focus-visible:bg-primary group-focus-visible:text-on-primary transition-all duration-300 ${classNames}`}
        >
            {numberToAlphabet(index)}
        </span>
        {/* A pause between the letter and the answer, so screen readers don't run them together */}
        <span className="sr-only">, </span>
        {answer}
    </>
);
